import { useIntl } from 'react-intl';

const useDefaultMaxLengthFieldError = () => {
  const intl = useIntl();

  return (max: number) => ({
    max,
    message: intl.formatMessage(
      { id: 'commons.form.errors.maxLength' },
      { max },
    ),
  });
};

export default useDefaultMaxLengthFieldError;
